<template>
    <div>
        <RaiseTab name="2">{{formData && formData.title}}</RaiseTab>
        <RaiseTicketPrices v-loading="dataLoading" :formData.sync="formData"></RaiseTicketPrices>
        <div class="page-group-box MT10">
            <el-button @click="goBack">返回</el-button>
            <el-button
                type="primary"
                @click="onSubmit"
                :loading="btnLoading"
                >保存</el-button
            >
        </div>
    </div>
</template>

<script>
import RaiseTab from './components/raise-tab';
import RaiseTicketPrices from './components/raise-ticketPrices-list';

export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components:{RaiseTab,RaiseTicketPrices},
    data(){
        return {
            formData:{   
                raiseTicketPrices:[]
            },
            btnLoading: false,
            dataLoading: false,
            redirect: this.$route.query.redirect || `/raise/project/list`,
        }
    },
    created() {
        this.getData();
    },
    methods:{
        // 获取详情
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/raise/info",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...result,
                    }
                    
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //提交
        onSubmit() {
            this.btnLoading = true;
            this.$request({
                url: "/raise/publish/price",
                method: "POST",
                data: { 
                    id: parseInt(this.id),
                    // opType: opType,
                    raiseTicketPrices: this.formData.raiseTicketPrices
                },
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$confirm('是否返回列表', '操作成功', {
                            type: 'success',
                            center: true,
                            confirmButtonText:'返回列表',
                            cancelButtonText:'留在当前页面',
                            closeOnClickModal: false
                        }).then(() => {
                            this.goBack();
                        }).catch(() => {
                            this.getData();
                        })
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>